import API from './axios';

function imageForm(files, overwrite) {
  const form = new FormData();
  files.forEach((file) => form.append('images', file, file.name));
  form.append('overwrite', String(overwrite));
  return form;
}

export const analizarImagenes = (files, overwrite = false) =>
  API.post('/product-images-bulk/analyze', imageForm(files, overwrite), {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const procesarImagenes = (files, overwrite = false) =>
  API.post('/product-images-bulk/process', imageForm(files, overwrite), {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
